import { Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-con-boolean',
  templateUrl: './d-con-boolean.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DConBooleanComponent),
      multi: true
    }
  ]
})
export class DConBooleanComponent extends DynamicComponentBase {
  static KEY = 'd-con-boolean';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {
    if (!Array.isArray(config.dataSource)) {
      config.dataSource = [
        {
          value: true,
          label: '是'
        },
        {
          value: false,
          label: '否'
        }
      ];
    }
  }
}
